<template>
  <ModalWrapper
    :modalName="modalName"
    maxWidth="max-w-2xl"
    :closeButton="false"
  >
    <button
      class="absolute top-3 lg:top-7 right-2 md:right-5 rounded-full h-10 w-10 flex items-center justify-center transition-ease-in-out hover:cursor-pointer"
      @click="cancel()"
    >
      <img src="@/assets/images/base/icons/close-modal.svg" loading="lazy" />
    </button>
    <div class="">
      <div class="w-full">
        <p
          class="text-primary-100 text-22 lg:text-2xl text-center lg:text-left font-medium mb-4"
        >
          {{ $t("patients.sign_in_to_add_other_person_data") }}
        </p>
      </div>

      <div class="overflow-auto max-h-[60vh]">
        <div class="mb-6 flex flex-col">
          <AddPatientSection
            ref="adultSection"
            age="adult"
            :isFirstPatientMode="true"
          />
        </div>

        <div class="mt-5">
          <span class="text-sm text-neutral-20 font-medium">
            {{ $t("patients.up_to_5_patients_can_be_added") }}
          </span>
        </div>
      </div>

      <div>
        <div
          class="flex justify-center md:justify-end items-center space-x-8 text-sm mt-4"
        >
          <button
            @click="cancel"
            class="text-primary-main font-semibold hover:text-primary-light transition-ease-in-out"
          >
            {{ $t("action.cancel") }}
          </button>

          <Button
            theme="secondary"
            class="w-40 py-2 md:p-4 relative"
            @click="onClickConfirm"
          >
            {{ $t("action.confirm") }}
          </Button>
        </div>
      </div>
    </div>
  </ModalWrapper>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import ModalWrapper from "@/components/Core/ModalWrapper.vue";
import Button from "@/components/Core/ButtonBase.vue";
import AddPatientSection from "@/components/Patient/AddPatientSection.vue";

export default {
  name: "AddCurrentPatientModal",
  components: {
    ModalWrapper,
    Button,
    AddPatientSection,
  },
  data() {
    return {
      modalName: "addCurrentPatientModal",
      asignedPatients: [],
    };
  },
  computed: {
    confirm() {
      return this.getModalData(this.modalName).onConfirm;
    },
    ...mapGetters({
      patientsIds: "checkout/getPatientsIds",
      getModalData: "modals/getModalData",
    }),
  },
  methods: {
    updateCart() {
      this.saveTmpPatients();
      this.assignCartToPatients(this.patientsIds);
    },
    cancel() {
      this.clearTmpPatients();
      this.closeModal("addCurrentPatientModal");
    },
    async onClickConfirm() {
      const isValid = await this.$refs.adultSection.validate();

      if (isValid) {
        this.updateCart();
        if (this.confirm instanceof Function) {
          this.confirm();
        }
        this.closeModal("addCurrentPatientModal");
      }
    },
    ...mapActions({
      assignCartToPatients: "cart/assignCartToPatients",
    }),
    ...mapMutations({
      closeModal: "modals/closeModal",
      clearTmpPatients: "checkout/clearTmpPatients",
      saveTmpPatients: "checkout/saveTmpPatients",
      clearCart: "cart/clearAll",
    }),
  },
};
</script>
